import BikeFrontSide from '~/assets/icons/BikeFrontSide';
import BikeFrontalWheel from '~/assets/icons/BikeFrontWheel';
import BikeLeftSide from '~/assets/icons/BikeLeftSide';
import BikeRearWheel from '~/assets/icons/BikeRearWheel';
import BikeRightSide from '~/assets/icons/BikeRightSide';
import FileIcon from '~/assets/icons/File';
import FrontGearShift from '~/assets/icons/FrontGearShift';
import RatchetsGroupIcon from '~/assets/icons/RatchetsGroupIcon';
import RearGearShift from '~/assets/icons/RearGearShift';
import SerialIcon from '~/assets/icons/SerialIcon';
import { DocumentType } from '~/constants/documentType';

export const documentTypeMap: Partial<Record<DocumentType, { key: string; label: string; icon: any }>> = {
  [DocumentType.NotaFiscaOuDeclaracaoDePropriedade]: {
    key: 'invoice',
    label: 'Nota fiscal ou declaração de propriedade',
    icon: FileIcon
  },
  [DocumentType.FotoDoNumeroDeSerie]: {
    key: 'serial_number_photo',
    label: 'Foto do número de série',
    icon: SerialIcon
  },
  [DocumentType.FotoDaVisaoGeralDoEquipamento]: {
    key: 'overview',
    label: 'Foto da visão geral do equipamento',
    icon: FileIcon
  },
  [DocumentType.FotoGrupoCatracas]: {
    key: 'ratchets_group',
    label: 'Foto da catraca',
    icon: RatchetsGroupIcon
  },
  [DocumentType.FotoDasRodas]: {
    key: 'wheels',
    label: 'Foto das rodas',
    icon: BikeFrontalWheel
  },
  [DocumentType.FotoDoAcessorio]: {
    key: 'accessory',
    label: 'Foto do acessório',
    icon: FileIcon
  },
  [DocumentType.Outros]: {
    key: 'other',
    label: 'Outros',
    icon: FileIcon
  },
  [DocumentType.CPF]: {
    key: 'cpf',
    label: 'CPF',
    icon: FileIcon
  },
  [DocumentType.CNPJ]: {
    key: 'cnpj',
    label: 'CNPJ',
    icon: FileIcon
  },
  [DocumentType.RG]: {
    key: 'rg',
    label: 'RG',
    icon: FileIcon
  },
  [DocumentType.BoletimDeOcorrencia]: {
    key: 'boletim_ocorrencia',
    label: 'Boletim de ocorrência',
    icon: FileIcon
  },
  [DocumentType.OrcamentoDeReparo]: {
    key: 'orcamento_reparo',
    label: 'Orçamento de reparo',
    icon: FileIcon
  },
  [DocumentType.FotoDaVisaoGeralDoEquipamentoDianteiraLadoDireito]: {
    key: 'right_side_overview',
    label: 'Visão geral do equipamento (LD)',
    icon: BikeRightSide
  },
  [DocumentType.FotoDaVisaoGeralDoEquipamentoDianteiraLadoEsquerdo]: {
    key: 'left_side_overview',
    label: 'Visão geral do equipamento (LE)',
    icon: BikeLeftSide
  },
  [DocumentType.FotoRodaDianteira]: {
    key: 'front_wheel',
    label: 'Foto da roda dianteira',
    icon: BikeFrontalWheel
  },
  [DocumentType.FotoRodaTraseira]: {
    key: 'rear_wheel',
    label: 'Foto da roda traseira',
    icon: BikeRearWheel
  },
  [DocumentType.FotoFrontal]: {
    key: 'front',
    label: 'Foto frontal',
    icon: BikeFrontSide
  },
  [DocumentType.FotoCambioDianteiro]: {
    key: 'front_gear_shift',
    label: 'Foto do câmbio dianteiro',
    icon: FrontGearShift
  },
  [DocumentType.FotoCambioTraseiro]: {
    key: 'rear_gear_shift',
    label: 'Foto do câmbio traseiro',
    icon: RearGearShift
  }
};
